import React from 'react'
import { useSelector } from 'react-redux'
import { DUE_DATE_DRAWER_STAGES } from 'app-constants'
import { DueDate } from './components'
import { DueDateDisabled } from './components/disabled'
import { DueDateSuccess } from './components/success'

export function DueDateDrawer() {
  const { stage } = useSelector(({ drawer }) => drawer)

  return stages()[stage]
}
function stages() {
  return {
    [DUE_DATE_DRAWER_STAGES.INITIAL]: <DueDate />,
    [DUE_DATE_DRAWER_STAGES.SUCCESS]: <DueDateSuccess />,
    [DUE_DATE_DRAWER_STAGES.DISABLED]: <DueDateDisabled />,
  }
}
